export default "__VITE_ASSET__IXfrR3lc__"